import { FC, FormEvent, ReactNode } from 'react';
import { $Formutil, connect } from 'react-bootstrap-formutil';
import { useNavigate } from 'react-router-dom';
import BackNextButtons, { BackNextButtonsProps } from 'components/BackNextButtons';
import ScrollTop from 'components/base/ScrollTop';
import Debug from 'components/Debug';
import Toast from 'components/Toast';
import classlist from 'utils/classlist';

export interface ContainerProps {
    $formutil: $Formutil;
    className?: string;
    children?: ReactNode;
    onSubmit?: () => void;
    footerButtonsProps?: BackNextButtonsProps;
}

const Container: FC<ContainerProps> = ({ $formutil, className, children, onSubmit, footerButtonsProps }) => {
    const navigate = useNavigate();
    const { $invalid, $batchState, $getFirstError, $errors, $params } = $formutil;

    const handleSubmit = (ev: FormEvent) => {
        ev.preventDefault();

        if ($invalid) {
            $batchState({
                $dirty: true,
                $touched: true
            });

            Toast.show($getFirstError());
        } else {
            if (onSubmit) {
                onSubmit();
            } else {
                navigate('../summary');
            }
        }
    };

    return (
        <form className={classlist(className, 'confirm-container')} noValidate onSubmit={handleSubmit}>
            <ScrollTop />
            {children}
            <BackNextButtons
                sticky
                hidePrev
                nextBtnProps={{
                    content: __('返回')
                }}
                {...footerButtonsProps}
            />
            <Debug data={$params} title="$params" />
            <Debug data={$errors} title="$errors" />
        </form>
    );
};

export default connect(Container);
